const BASE_API = process.env.MIX_ENDLESS_API_URL

const state ={
	favorites:null,
}
const getters = {
	favoritesGetter:({favorites}) => favorites,
}

const mutations = {
	setFavorites : (state,payload) => state.favorites = payload,
	setDeleteFavorites:(state,payload) => {
		if (state.favorites !== null) {
			state.favorites = state.favorites.filter(fav => fav.id !== payload);
		}
	}

}

const actions = {
	async getFavorites({commit}){
		await this.$axios.get(`${BASE_API}/favorite-campuses-ids`).then(res => {
			commit('setFavorites',res.data.result)
		})
	},
	async createFavorites({commit}, payload){
		await this.$axios.post(`${BASE_API}/favorites`,payload).then(res => {
			commit('setFavorites',res.data.result.data)
		})
	},
	async deleteFavorites({commit}, payload){
		$('#loading').show();
		await this.$axios.delete(`${BASE_API}/favorites/${payload.campus_id}`).then(res => {
			commit('setDeleteFavorites',payload.campus_id)
			$('#loading').hide();
		})
	},
}

export default {namespaced:true,state,getters,mutations,actions}
